import { Typography } from "@mui/material";
import type { PortalOverview } from "@/types";
import { formatDate } from "@/utils/formatDateTime.ts";
import * as copy from "@/utils/vulnerabilityCopy.ts";

/** "Last 30 days · Updated <date>" from the snapshot; nothing while the window is not known. */
export default function WindowCaption({ overview }: { readonly overview: PortalOverview | undefined }) {
  const coverage = overview?.available ? overview.coverage : null;
  if (!coverage) return null;
  const updated = overview?.updated_at ?? null;
  return (
    <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }}>
      {copy.windowCaption(coverage.window_days, updated === null ? null : formatDate(updated))}
    </Typography>
  );
}
